import React, { memo } from 'react';

import { EmptyRateDisplayValue } from './empty-rate-display-value';

import FormattedCurrency from '../../../../components/formatted-currency';
import { CurrencyPropType } from '../../../../prop-types/currency';

export const RateAmount = memo(({ rate }) => {
  if (rate?.value) {
    return <FormattedCurrency currencyCode={rate.code} value={rate.value} />;
  }

  return <EmptyRateDisplayValue />;
});

RateAmount.propTypes = {
  rate: CurrencyPropType,
};
